import PublicAppointmentPage from "@/components/booking/public/PublicAppointmentPage";

export default function PublicAppointmentSummaryPage() {
  return <PublicAppointmentPage variant="summary" />;
}
